import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

export const MODULES = [
  CommonModule,
  MatCardModule,
  MatIconModule,
  MatButtonModule,
];

@Component({
  selector: 'app-pigeons-video',
  templateUrl: './pigeons-video.component.html',
  styleUrls: ['./pigeons-video.component.scss'],
  imports: [...MODULES],
})
export class PigeonsVideoComponent implements OnInit {
  private sanitizer = inject(DomSanitizer);

  urlTutorialVideo = signal<SafeResourceUrl>(undefined);
  closeVideo = output();

  ngOnInit(): void {
    this.urlTutorialVideo.set(
      this.sanitizer.bypassSecurityTrustResourceUrl(
        'https://youtube.com/embed/NuXuZ51eBPo'
      )
    );
  }

  onCloseVideo(): void {
    this.closeVideo.emit();
  }
}
